import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {Card} from 'shells/card/card';
import {STATE_IDS} from 'shells/maps/consts';
import {StateHoverTooltip} from 'shells/maps/state-hover-tooltip';
import {UsaMap} from 'shells/maps/usa-map';
import {RankedStatBarList} from 'shells/ranked-stat-bar/ranked-stat-bar-list';
import {SectionLabel} from 'shells/typography/section-label';

import {SpecialState} from '../summary/special-state';
import type {TopTenReport} from '../summary/use-get-top-ten-report';

import styles from './companies-map-wrapper.module.css';

type Props = {
    topTenReport: TopTenReport | null | undefined;
    isLoading: boolean;
    isError: boolean;
    getFilteredListUrlPath: (filter: FilterObject) => string;
};
export function CompaniesMapWrapper(props: Props) {
    const {topTenReport, isLoading, isError} = props;

    const totalSum = topTenReport ? topTenReport.reduce((sum, data) => sum + data.count, 0) : 1;

    const rankedStats = topTenReport
        ? topTenReport.map((data) => ({
              label: data.bucket,
              sublabel: STATE_IDS[data.bucket],
              percentValue: data.count / totalSum,
              linkTo: props.getFilteredListUrlPath({
                  region: {
                      selected: 'exactMatch',
                      data: {selected: 'state', country: 'US', state: data.bucket},
                  },
              }),
          }))
        : new Array(10).fill(undefined);

    if (rankedStats.length < 10) {
        rankedStats.push(...new Array(10 - rankedStats.length).fill(undefined));
    }

    return (
        <div>
            <SectionLabel noBottomBorder={true}>Map</SectionLabel>
            <Card hasBorder={true} fitHeight={true}>
                <div className={styles['companies-map-wrapper']}>
                    {isLoading || isError ? (
                        <SpecialState state={isError ? 'error' : 'loading'} />
                    ) : undefined}
                    <div className={styles['map-svg-container']}>
                        <UsaMap
                            // @ts-expect-error
                            rankedStateIds={
                                topTenReport
                                    ? topTenReport.map((data) => STATE_IDS[data.bucket])
                                    : []
                            }
                            // @ts-expect-error
                            getHoverTooltipComponent={(stateId: string) => {
                                if (!topTenReport) return null;

                                const dataPos = topTenReport.findIndex(
                                    (data) => STATE_IDS[data.bucket] === stateId
                                );

                                if (dataPos !== -1) {
                                    // @ts-expect-error
                                    const numCompanies = topTenReport[dataPos].count;

                                    return (
                                        <StateHoverTooltip
                                            // @ts-expect-error
                                            stateName={topTenReport[dataPos].bucket}
                                            dataPoint={`${numCompanies} ${
                                                numCompanies === 1 ? 'company' : 'companies'
                                            }`}
                                        />
                                    );
                                }

                                return null;
                            }}
                        />
                    </div>
                    <RankedStatBarList rankedStats={rankedStats} />
                </div>
            </Card>
        </div>
    );
}
